import React from 'react'
import { Global, css } from '@emotion/react'
import NunitoSansRegular from './fonts/NunitoSans_10pt-Regular.ttf'
import NunitoSansThin from './fonts/NunitoSans_10pt-Light.ttf'
import NunitoSansMedium from './fonts/NunitoSans_10pt-Medium.ttf'
import NunitoSansSemiBold from './fonts/NunitoSans_10pt-SemiBold.ttf'
import NunitoSansBold from './fonts/NunitoSans_10pt-Bold.ttf'

export const GlobalStyles = (props) => {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansRegular}) format('truetype');
        }

        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansThin}) format('truetype');
          font-weight: 100;
        }

        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansMedium}) format('truetype');
          font-weight: 700;
        }

        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansSemiBold}) format('truetype');
          font-weight: 800;
        }

        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansBold}) format('truetype');
          font-weight: 900;
        }

        @font-face {
          font-family: 'Maxxia';
          src: local('Maxxia'), url(${NunitoSansBold}) format('truetype');
          font-weight: bold;
        }

        body {
          font-family: Maxxia, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
            'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
            'Noto Color Emoji';

          overflow-x: hidden;
          word-break: break-word;
        }
        // general.scss styles are moved here please remove whichever is not required in future

        input[type='number']::-webkit-inner-spin-button,
        input[type='number']::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .text-header {
          font-weight: 700;
          text-transform: uppercase;
        }

        .ui-list-a {
          padding-left: 50px;
          position: relative;
          .ui-list-icon {
            position: absolute;
            top: 0;
            left: 15px;
          }
        }

        .text-dark {
          color: ${props.theme.colors.linkColor};
        }

        .text-brand {
          color: ${props.theme.colors.primary};
        }

        .text-positive {
          color: ${props.theme.colors.positive3};
        }

        .text-green {
          color: ${props.theme.colors.alertGreen};
        }

        .background-green {
          background: ${props.theme.colors.alertGreen2};
        }

        .link {
          color: inherit !important;
          font-weight: 700;
          text-decoration: underline;
          &-primary {
            color: ${props.theme.colors.linkColor};
            font-size: 14px;
          }
        }

        .text-underline {
          text-decoration: underline !important;
        }

        .clickable {
          cursor: pointer;
        }
        // text sizes

        .text-smaller {
          font-size: ${props.theme.font.size.smaller};
        }
        .text-small {
          font-size: ${props.theme.font.size.small};
        }
        .text-medium {
          font-size: ${props.theme.font.size.medium} !important;
        }
        .text-larger {
          font-size: ${props.theme.font.size.larger};
        }
        .text-largest {
          font-size: ${props.theme.font.size.largest};
        }
        //forms

        .errorMsg {
          font-size: 18px;
          color: red;
          padding: 5px 0;
          display: none;
        }
        .show {
          display: block;
        }
        //please remove if component specific
        // margin and paddings
        .mb-13rem {
          margin-bottom: 1.3rem;
        }

        .mb-24 {
          margin-bottom: 24px;
        }

        //buttons
        .bg-brand,
        .bg-brand:hover {
          background: ${props.theme.colors.primary};
          background-color: ${props.theme.colors.primary};
          border-color: ${props.theme.colors.primary};
        }

        .btn.bg-brand:hover {
          opacity: 0.9;
        }

        //move to banner specific component
        .banner-bg {
          position: relative;
          width: 100%;
          overflow-y: hidden !important;
          overflow-x: hidden !important;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: right;
          padding: 37px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .banner-container {
            width: 100%;
          }

          .banner-content {
            color: ${props.theme.colors.white};
            width: 100%;
          }

          .banner-content.theme-dark {
            color: ${props.theme.colors.bodyColor};
          }
        }

        //make these component specific
        //termsAndConditions.js
        .terms-conditions {
          padding: 72px 0;
          border-top: 1px solid #cccccc;
          border-bottom: 1px solid #cccccc;
        }
        .terms-conditions li {
          margin-bottom: 20px;
        }
        .terms-conditions ol {
          padding-left: 20px;
        }

        //contactUsDialog.js
        .mandatory::after {
          content: '*';
          color: red;
        }

        .pd-40 {
          padding: 40px;
        }

        .width-100perc {
          width: 100%;
        }

        // contentSection.js
        .bg-grey-secondary {
          background: ${props.theme.colors.primaryLightText};
        }

        .text-grey-a {
          color: ${props.theme.colors.bodyColor};
        }

        // summarySection.js
        .pl-14 {
          padding-left: 14px;
        }

        .mb-12 {
          margin-bottom: 12px;
        }

        .card-shadow {
          box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.16);
          -webkit-box-shadow: 0px px 16px rgba(0, 0, 0, 0.16);
        }
      `}
    />
  )
}
